import { render, staticRenderFns } from "./ShareTransferCreateForm.vue?vue&type=template&id=ceffcc24&"
import script from "./ShareTransferCreateForm.vue?vue&type=script&lang=js&"
export * from "./ShareTransferCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports